import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import BossClient from "./boss-client";
/**
 *
 * @description 用于多boss复报
 */

var BossGroupClient = /*#__PURE__*/function () {
  function BossGroupClient(configs) {
    _classCallCheck(this, BossGroupClient);

    this.clients = [];
    this.clients = configs.map(function (config) {
      return new BossClient(config);
    });
  }

  _createClass(BossGroupClient, [{
    key: "report",
    value: function report(params, event) {
      this.clients.forEach(function (client) {
        return client.report(params, event);
      });
    }
  }]);

  return BossGroupClient;
}();

export { BossGroupClient as default };